import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import "../NCLAdmin/StudentResponses.scss";
import { AssessmentName } from "../Student/Reusablecomponents/RegularFunctions";
import InternetChecking from "../Student/Reusablecomponents/Network";
import { useSelector } from "react-redux";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import { GoDownload } from "react-icons/go";
import notify from "../ReusableComponents/ToastifyAlerts";
import axiosInstance from "../ReusableComponents/Axios";
import { LoadContext } from "../ReusableComponents/LoadingContex";
import DataTable from "../Student/Reusablecomponents/DataTable/DataTable";
const DownloadStudentResponsesTech = () => {
  const GradeRef = useRef();
  const { SetLoad, Load } = useContext(LoadContext);
  const [SelectSubject, SetSelectSubject] = useState([]);
  const [SGrade, SetSGrade] = useState([]);

  const [SelectINID, SetSelectINID] = useState();
  const [SRSData, SetSRSData] = useState();
  const [AssDates, SetAssDates] = useState();
  const USYear = useSelector((state) => state.SelecYearData.SYear);

  const SheetDownload = async (data) => {
    const workbook = new ExcelJS.Workbook();
    data.forEach((Responce, index) => {
      const worksheetData = [
        [...Object.keys(Responce.SheetDetails[0]).map((key) => key)],
        ...Responce.SheetDetails.map((item, index) => [
          ...Object.keys(item).map((key, i) => item[key]),
        ]),
      ];
      const worksheet = workbook.addWorksheet(Responce.SheetName);
      worksheet.views = [{ state: "frozen", ySplit: 2 }];
      worksheet.mergeCells(
        1,
        1,
        1,
        Object.keys(Responce.SheetDetails[0]).length
      );
      worksheet.getCell(1, 1).value = `${SelectRow?.instituteCode} - Student Responses Data Sheet - ${SelectRow?.examAvailabilityEndDate} - ${SelectRow?.assessmentTypeName}`;
      worksheet.getCell("A1").alignment = { vertical: "middle" };
      worksheet.getRow(1).height = 30;
      worksheet.getRow(1).font = { bold: true };
      worksheet.getRow(1).eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "95b3d7" },
        };
      });
      worksheet.autoFilter = {
        from: { row: 2, column: 1 },
        to: { row: 2, column: Object.keys(Responce.SheetDetails[0]).length },
      };

      worksheet.columns = worksheetData[0].map(() => ({ width: 23 }));
      worksheetData.forEach((data, index) => {
        const row = worksheet.addRow(data);
        row.eachCell((cell) => {
          cell.alignment = { horizontal: "center", vertical: "middle" };
          if (cell.value && cell.value.length > 15) {
            cell.alignment = { wrapText: true, vertical: "middle" };
          }
        });
      });

      worksheet.getRow(2).eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "d9e1f2" },
        };
      });
      worksheet.getRow(2).font = { bold: true };

      worksheet.eachRow((row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    // saveAs(
    //   blob,
    //   `StudentResponses_${SelectRow?.instituteCode}_${SelectRow?.examAvailabilityEndDate}`
    // );
    if (SelectRow?.instituteId === 1 || SelectRow?.instituteId === 3) {
      saveAs(
        blob,
        `${SelectRow?.assessmentTypeName}_${SelectRow?.instituteCode}_${SelectRow?.regionName}_${SGrade}_${SelectRow?.examAvailabilityStartDate}.xlsx`,
      );
    } else if (
      SelectRow?.instituteId === 8 ||
      SelectRow?.instituteId === 9 ||
      SelectRow?.instituteId === 5
    ) {
      saveAs(
        blob,
        `${SelectRow?.assessmentTypeName}_${SelectRow?.societyCode}_${SGrade}_${SelectRow?.examAvailabilityStartDate}.xlsx`,
      );
    } else {
      saveAs(
        blob,
        `${SelectRow?.assessmentTypeName}_${SelectRow?.instituteCode}_${SGrade}_${SelectRow?.examAvailabilityStartDate}.xlsx`,
      );
    }
    TriggerFilegeneration(SelectRow);
    SetLoad((prev) => !prev);
    SetSelectRow();
  };
  const DownloadReport = async () => {
    // if (SelectSubject.length > 0 && SGrade.length > 0) {
    SetLoad((prev) => !prev);
    const GS = SGrade?.length > 1 ? "grade" : "subjectName";
    try {
      const res = await axiosInstance.get(`/NCLAdmin/GetStudentAssessmentResponseByMultipleGradeAndSubject?ContestCreationId=${SelectRow?.contestCreationId}&SubjectName=${SelectSubject.join(",")}&InstituteId=${SelectRow?.instituteId}&AssessmentType=${SelectRow?.assessmentType}&Grade=${SGrade?.join(
        ",")}&RegionId=${SelectRow?.regionId}&StateId=${SelectRow?.stateId}&SocietyId=${SelectRow?.societyId}`);
      if (res.data[0]?.[GS]) {
        const data = res.data.reduce((acc, student, index) => {
          const grade = student[GS];
          let gradeObj = acc.find(
            (item) =>
              item.SheetName ===
              (SGrade?.length > 1 ? `Grade ${grade}` : grade)
          );
          if (!gradeObj) {
            gradeObj = {
              SheetName: SGrade?.length > 1 ? `Grade ${grade}` : grade,
              SheetDetails: [],
            };
            acc.push(gradeObj);
          }
          const questions = [];
          for (
            let i = 1;
            i <=
            Object.keys(student).filter((key) => key.startsWith("qId"))
              .length;
            i++
          ) {
            questions.push({
              [`Q${i}_ID`]: student[`qId_${i}`],
              [`Q${i}_difficulty_level`]: student[`dL_${i}`],
              [`Q${i}_question_type`]: student[`qType_${i}`],
              [`Q${i}_key`]: student[`key_${i}`].replace(/<\/?p>/g, ""),
              [`Q${i}_LO`]: student[`lO_${i}`],
              [`Q${i}_credit`]: student[`q${i}_Credits`],
              [`Q${i}_response_marked`]: student[`q${i}_Response_marked`],
            });
          }
          const studentData = {
            "S.No": gradeObj.SheetDetails.length + 1,
            Instiute: SelectRow?.instituteCode,
            [SelectINID?.value === 1 || SelectINID?.value === 3 ? "Region" : "State"]:
              SelectINID?.value === 1 || SelectINID?.value === 3
                ? student.regionName
                : student.stateName,
            District: student.districtName,
            SchoolName: student.schoolName,
            "Student LoginId": student.loginId,
            Grade: student.grade,
            ...(SelectRow?.societyCode === "NATCO" && {
                PSTStatus: student.pstStatus,
              }),
            Gender: student.gender,
            "Assessment Date": student.testStartTime,
            "Time on subject mins": student.timeInMin,
            "Total time on assesment mins": student.totalTime,
            Subject: student.subjectName,
            ...Object.assign({}, ...questions),
          };
          gradeObj.SheetDetails.push(studentData);
          return acc;
        }, []);

        SheetDownload(data);
      } else {
        notify("No data found. Please select another option", "error");
        SetSelectRow();
        SetLoad((prev) => !prev);
      }
    }
    catch (err) {
      notify("No data found. Please select another option", "error");
      SetSelectRow();
      SetLoad((prev) => !prev);
    }

    // } else {
    //   notify(`Please select ${SGrade.length === 0 ? "Grade" : "Subject"}`, "warning");
    // }
  };

  const RenderSubjects = (SG) => {
    SetSGrade(SG);
    SetSelectSubject([]);
    const hasBelowOrEqual10 = SG.some(value => value <= 10);
    const hasAbove10 = SG.some(value => value > 10);
    switch (true) {
      // case hasBelowOrEqual10 && hasAbove10:
      //   SetSelectSubject([
      //     "English",
      //     "Mathematics",
      //     "Science",
      //     "Biology",
      //     "BioTechnology",
      //     "Physics and Chemistry",
      //   ]);
      //   break;
      case hasBelowOrEqual10:
        SetSelectSubject(["English", "Mathematics", "Science"]);
        break;
      case hasAbove10:
        SetSelectSubject([
          "English",
          "Mathematics",
          "Biology",
          "BioTechnology",
          "Physics and Chemistry",
        ]);
        break;
    }
    // HandleDownloadreport();
  };

  const HandleDownloadreport = (CCID, AType) => {
    if (SelectSubject.length > 0 && SGrade.length > 0) {
      if (SelectRow?.assessmentType !== 3) {
        DownloadReport(CCID, AType);
      } else if (SelectRow?.assessmentType === 3) {
        DownloadSamagra(CCID, AType);
      }
    } else {
      notify(`Please select ${SGrade.length === 0 ? "Grade" : "Subject"}`, "warning");
    }
  }

  const DownloadSamagra = async () => {
    SetLoad((prev) => !prev);
    try {
      const res = await axiosInstance.get(`/NCLAdmin/ReportsGetSamagraStudentsResponses?ContestCreationId=${SelectRow?.contestCreationId}&SubjectName=${SelectSubject.join(",")}&InstituteId=${SelectRow?.instituteId}&AssessmentType=3&Grade=${SGrade?.join(",")}
&RegionId=${SelectRow?.regionId}&StateId=${SelectRow?.stateId}&SocietyId=${SelectRow?.societyId}`);

      const QDetails = res.data.filter((item) => item?.sets === "Set2")
        .map((Qitem) => ({
          "questionId": Qitem?.questionId,
          "questionGrade": Qitem?.questionGrade,
          "lo": Qitem?.lo,
          Grade: Qitem.grade,
          Subject: Qitem.subjectName,
        }));
      const GS = SGrade?.length > 1 ? "grade" : "subjectName";
      const SDetails = res.data.filter((item) => item?.sets === "Set1")

      if (SDetails.length > 0) {
        const data = SDetails.reduce((acc, student, index) => {
          const grade = student[GS];
          let gradeObj = acc.find(
            (item) => item.SheetName === (SGrade?.length > 1 ? `Grade ${grade}` : grade)
          );
          if (!gradeObj) {
            gradeObj = {
              SheetName: SGrade?.length > 1 ? `Grade ${grade}` : grade,
              SheetDetails: [],
            };
            acc.push(gradeObj);
          }
          const questions = [];
          for (
            let i = 1;
            i <= student.noOfQuestion;
            i++
          ) {
            questions.push({
              [`q${i}_Credits`]:(student[`q${i}_Response_marked`] === "U" || student[`q${i}_Response_marked`] === "")  ? "U" : student[`q${i}_Credits`],
            });
          }
          const studentData = {
            "S.No": gradeObj.SheetDetails.length + 1,
            "schoolName": student.schoolName,
            District: student.district,
            loginId: student.loginId,
            "firstName": student.firstName,
            "lastName": student.lastName,
            Grade: student.grade,
             ...(SelectRow?.societyCode === "NATCO" && {
              PSTStatus: student.pstStatus,
            }),
            
            Subject: student.subjectName,
            schoolId: student.schoolId,
            ...Object.assign({}, ...questions),
          };
          gradeObj.SheetDetails.push(studentData);
          return acc;
        }, []);
        SamagraSheetDownload(QDetails, data)
      } else {
        notify("No data found. Please select another option", "error");
        SetSelectRow();
        SetLoad((prev) => !prev);
      }
    }
    catch (err) {
      SetSelectRow();
      SetLoad((prev) => !prev);
    }
  }
  const SamagraSheetDownload = async (QDetails, ResponceList) => {
    const GS = SGrade?.length > 1 ? "Grade" : "Subject";
    const emptyColumns = Array(SelectRow?.societyCode === "NATCO" ? 8 : 7).fill("");
    const workbook = new ExcelJS.Workbook();
    ResponceList.forEach((Responce, index) => {
      const worksheetData = [
        ["S.No", "SchoolId", "SchoolName", "District", "LoginId", "FirstName", "LastName", ...(SelectRow?.societyCode === "NATCO" ? ["PST Status"] : []), ...QDetails?.filter((item) => item[GS] === Responce?.SheetName)?.flatMap((item, index) => [`Q${index + 1}`])],

        [...emptyColumns, ...QDetails?.filter((item) => item[GS] === Responce?.SheetName)?.flatMap((item) => [item.questionId])],
        [...emptyColumns, ...QDetails?.filter((item) => item[GS] === Responce?.SheetName)?.flatMap((item) => [item?.questionGrade === "0" ? "Pre-primary" : item?.questionGrade])],
        [...emptyColumns, ...QDetails?.filter((item) => item[GS] === Responce?.SheetName)?.flatMap((item) => [item?.lo])],
        ...Responce?.SheetDetails?.map((item) =>
          [item?.[`S.No`], item?.schoolId, item?.schoolName, item?.District, item?.loginId, item?.firstName, item?.lastName,  ...(SelectRow?.societyCode === "NATCO" ? [item?.PSTStatus] : []),
          ...QDetails?.map((_, index) => item[`q${index + 1}_Credits`])
          ]),

      ];
      const worksheet = workbook.addWorksheet(`Grade - ${Responce.SheetDetails[0].Grade} - ${Responce.SheetDetails[0].Subject}`);
      // worksheet.views = [{ state: "frozen", ySplit: 8 }];
      worksheet.mergeCells(1, 1, 1, Object.keys(Responce.SheetDetails[0]).length - 2);
      worksheet.getCell(1, 1).value = `${SelectRow?.instituteCode} - Student Responses Data Sheet - ${SelectRow?.examAvailabilityStartDate} -  ${SelectRow?.assessmentTypeName}`;
      worksheet.getCell("A1").alignment = { vertical: "middle" };
      worksheet.getRow(1).height = 30;
      worksheet.getRow(1).font = { bold: true };
      worksheet.getRow(1).eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "95b3d7" },
        };
      });
      // worksheet.autoFilter = {
      //   from: "A8",
      //   to: `${String.fromCharCode(
      //     64 +
      //     Object.keys(Responce.SheetDetails[0]).filter(
      //       (key) => !key.startsWith("Q")
      //     ).length
      //   )}8`,
      // };
      if (worksheet.length > 0) {
        const filterRange = {
          from: `${worksheet[0]}1`,
          to: `${worksheet[worksheet.length - 1]}1`,
        };
        worksheet.autoFilter = filterRange;
      }
      worksheet.columns = worksheetData[0].map(() => ({ width: 20 }));
      worksheetData.forEach((data, index) => {
        const row = worksheet.addRow(data);
        // if (index < 5 || index === 6) {
        //   questionHeaders.map((_, i) => {
        //     worksheet.mergeCells(
        //       index + 2,
        //       emptyColumns.length + i + 2 + i,
        //       index + 2,
        //       emptyColumns.length + i + 3 + i
        //     );
        //   });
        // }

        row.eachCell((cell) => {
          cell.alignment = { horizontal: "center", vertical: "middle" };
          if (cell.value && cell.value.length > 15) {
            cell.alignment = { wrapText: true, vertical: "middle" };
          }
        });
      });

      // worksheetData.forEach((data, index) => {
      //   // if (index < 10) {
      //   //   worksheet.mergeCells(3, index + 1, 9, index + 1);
      //   // }
      //   if (index < 7) {
      //     worksheet.getRow(index + 2).eachCell((cell) => {
      //       cell.fill = {
      //         type: "pattern",
      //         pattern: "solid",
      //         fgColor: { argb: "d9e1f2" },
      //       };
      //     });
      //   }
      // });
      worksheet.getRow(2).font = { bold: true };
      worksheet.eachRow((row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    // saveAs(
    //   blob,
    //   `StudentResponses_${SelectRow?.instituteCode}_${SelectRow?.examAvailabilityEndDate}.xlsx`
    // );
    if (SelectRow?.instituteId === 1 || SelectRow?.instituteId === 3) {
      saveAs(
        blob,
        `${SelectRow?.assessmentTypeName}_${SelectRow?.instituteCode}_${SelectRow?.regionName}_${SGrade}_${SelectRow?.examAvailabilityStartDate}.xlsx`,
      );
    } else if (
      SelectRow?.instituteId === 8 ||
      SelectRow?.instituteId === 9 ||
      SelectRow?.instituteId === 5
    ) {
      saveAs(
        blob,
        `${SelectRow?.assessmentTypeName}_${SelectRow?.societyCode}_${SGrade}_${SelectRow?.examAvailabilityStartDate}.xlsx`,
      );
    } else {
      saveAs(
        blob,
        `${SelectRow?.assessmentTypeName}_${SelectRow?.instituteCode}_${SGrade}_${SelectRow?.examAvailabilityStartDate}.xlsx`,
      );
    }
    TriggerFilegeneration(SelectRow);
    SetLoad((prev) => !prev);
    notify("Student Responses sheet downloaded successfully", "success");
    SetSelectRow();
  };
  // Below is new concept
  useEffect(() => {
    if (USYear?.value) {
      GetGenerateDetails();
    }
  }, [USYear?.value])
  const [GReports, SetGReports] = useState([]);
  const [SelectRow, SetSelectRow] = useState();
  const GetGenerateDetails = async () => {
    try {
      const res = await axiosInstance.get(`/NCLAdmin/GetAssessmentSchedulesToGenerateResponses?AcademicYear=${USYear?.value}`);
      SetGReports(res.data);
    }
    catch (err) {
      console.log(err)
    }
  };

  const columns = [
    { name: "Test Type", selector: "assessmentTypeName" },
    { name: "Institute / Society", selector: "instituteName" },
    { name: "Region / State", selector: "marks", cell: (row) => row.regionName || row.stateName },
    { name: "Assessment Date", selector: "examAvailabilityStartDate" },
    { name: "Subjects", selector: "subjectName", },
    { name: "Grades", selector: "grades", },
    { name: "Download File", cell: (row) => <span className="CPointer" onClick={() => { GradeDownloadSheet(row, row.grades); }}><GoDownload fontSize={20}/></span>}
  ];
  const GradeDownloadSheet = async (row, grade) => {
    // RenderSubjects([grade]);
    const Subjects = row.subjectName.split(",").map((Sub) => Sub.trim());
    SetSelectSubject(Subjects);
    SetSGrade([grade]);
    SetSelectRow(row);
  }
  useMemo(() => {
    if (SelectRow) {
      HandleDownloadreport();
    }
  }, [SelectRow])
  // Above is new concept

  const TriggerFilegeneration = async (Row) => {
    // try {
    //   const res = await axiosInstance.get(`/NCLAdmin/UpdateFileGeneratedStatus?AssessmentScheduledId=${Row?.assessmentScheduleId}&RegionId=${Row?.regionId || ""}&Grade=${SGrade?.[0]}`);
    //   console.log("res.data", res.data);
    //   GetGenerateDetails();
    // }
    // catch (err) {
    //   console.log(err)
    // }
  }
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <div className="MainHeading"> Export Student responses data generation</div>

        <DataTable ShowPagination={true}  Dropdownvalues={[10, 25, 50, 100]} className="NCLDataTable Card mt-2"
          ShowPagecount={true} columns={columns} data={GReports} />
      </div>
    </>
  );
};
export default DownloadStudentResponsesTech;